import * as React from 'react';

import {FormLocationDefault} from './location-default';
import {FormLocationSelectWithinUS} from './location-within-us';
import type {LocationFormValue} from './types';

type Props = {
    value?: LocationFormValue;
    onChange: (formValue: {[field: string]: any}) => void;
    name: string;
    useProspectorStateSelector?: boolean;
    isNewLocationField?: boolean;
};

export const FormLocation = (props: Props) => {
    return props.isNewLocationField ? (
        <FormLocationSelectWithinUS
            value={props.value}
            onChange={props.onChange}
            name={props.name}
            useProspectorStateSelector={props.useProspectorStateSelector}
        />
    ) : (
        <FormLocationDefault value={props.value} onChange={props.onChange} name={props.name} />
    );
};
